import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "viewBox": "0 0 70.9 70.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 70.9 70.9\" id=\"icon-triangle\">\r\n<style type=\"text/css\">\r\n</style>\r\n<path class=\"st0\" d=\"M39.5,53.8l24-30c2.7-3.4,0.3-8.4-4-8.4h-48c-4.3,0-6.7,5-4,8.4l24,30C33.5,56.4,37.4,56.4,39.5,53.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol